export const BookingFormId = 'booking-form';
export const ViewBookingsFormId = 'view-booking-form';

export const SectionId = {
  step1: 's1',
  step2: 's2',
  step3: 's3',
};

export const BookingFormModel = {
  s1_onlineServiceF: {
    name: 's1.onlineServiceId',
    label: 'Service',
  },
  s2_locationF: {
    name: 's2.locationId',
    label: 'Location',
  },
  s2_clinicF: {
    name: 's2.clinicId',
    label: 'Clinic',
  },
  s3_selectDateF: {
    name: 's3.selectDate',
    label: 'Select Date',
  },

  s3_selectTimeF: {
    name: 's3.selectTime',
    label: 'Select Time',
  },
  s3_selectPractitionerF: {
    name: 's3.selectPractitioner',
  },
  s3_selectPractitionerIdF: {
    name: 'staffId',
  },
  s3_selectPractitionerNameF: {
    name: 'staffName',
  },
  s3_selectBooking: {
    name: 's3.selectBooking',
  },

  s4_firstNameF: {
    name: 's4.patient.firstName',
    label: 'First Name',
    placeholder: 'First Name',
  },
  s4_lastNameF: {
    name: 's4.patient.surname',
    label: 'Last Name',
    placeholder: 'Last Name',
  },
  s4_DOBF: {
    name: 's4.patient.DOB',
    label: 'Date of Birth',
    placeholder: 'Date of Birth',
  },
  s4_patientIdF: {
    name: 's4.patient.patientId',
  },
  s4_mobilePhoneF: {
    name: 's4.contact.phoneMobile',
    label: 'Mobile Phone',
    placeholder: 'Mobile Phone',
  },
  s4_emailF: {
    name: 's4.contact.email',
    label: 'Email Address',
    placeholder: 'Email Address',
  },
  s4_isReturnC: {
    name: 's4.isNew',
    label: 'Have you been to Mole Patrol before?',
    placeholder: 'Have you been to Mole Patrol before?',
  },
  s4_voucherF: {
    name: 's4.voucher',
    label: 'Voucher Code',
    placeholder: 'Voucher Code',
  },
  s5_verificationCodeF: {
    name: 's5.code',
    label: '',
    placeholder: '0',
  },
  s5_emailMobileF: {
    name: 's5.emailMobile',
    label: '',
  },
  s5_case: {
    name: 's5.case',
  },
  s4_employerF: {
    name: 's4.employer',
    label: 'Employer',
    placeholder: 'Employer',
  },
};

export const ViewBookingsFormModel = {
  firstNameF: {
    name: 'patient.firstname',
    label: 'First Name',
    placeholder: 'First Name',
  },
  lastNameF: {
    name: 'patient.lastname',
    label: 'Last Name',
    placeholder: 'Last Name',
  },
  DoBF: {
    name: 'patient.dob',
    label: 'Date of Birth',
    placeholder: 'Date of Birth',
  },
  mobilePhoneF: {
    name: 'patient.mobile',
    label: 'Mobile Phone',
    placeholder: 'Mobile Phone',
  },
  emailF: {
    name: 'patient.email',
    label: 'Email Address',
    placeholder: 'Email Address',
  },
  verificationCodeF: {
    name: 'verificationCode',
    label: '',
    placeholder: '0',
  },
};
